export default "__VITE_ASSET__COx4vwXU__"